import React from "react";
import "./InputFieldService.scss"; 
import {ReactComponent as ArrowDown} from "../../../src/assets/images/ArrowDown.svg"

const InputFieldService = ({ value = "",  showIcon = false, className = "", ...props }) => {
  return (
    <div className={`plan-input-container ${className}`}>
      {/* <input type="text" className="plan-input" value={value}  disabled {...props} />
       */}
       <div className="plan-input">
        {value}
        </div>
      {showIcon && <ArrowDown className="plan-input-icon" />}
    </div>
  );
};

export default InputFieldService;
